import { DiscordRpc } from "./discord-rpc";

export function Accounts() {
  return (
    <div className="space-y-4">
      <DiscordRpc />
    </div>
  );
}
